import { useGetPriceSegment } from "@grandvisionhq/fun-products";
import { mapProductProjectionToListingProduct } from "@grandvisionhq/products";
import { useIntl } from "@grandvisionhq/state";
import { useAsyncState, isDefined } from "@grandvisionhq/utils";
import { queryAlgolia } from "../../../utils/Algolia/utils/query-algolia.js";
function useAlgoliaSearch(algoliaConfig, searchOptions) {
  const intl = useIntl();
  const { priceSegment } = useGetPriceSegment();
  const { result } = useAsyncState(
    { result: [], hasError: false, isLoading: true },
    async () => {
      const result2 = await queryAlgolia(
        algoliaConfig,
        searchOptions
      );
      if (result2 === null) {
        console.error(`[useAlgoliaSearch]: Something went wrong searching Algolia.`);
        return { result: [], hasError: true, isLoading: false };
      }
      const mappedResult = result2.hits.map((product) => mapProductProjectionToListingProduct(product, intl, priceSegment)).filter(isDefined);
      return {
        result: mappedResult,
        hasError: false,
        isLoading: false
      };
    },
    [searchOptions, algoliaConfig, priceSegment]
  );
  return result;
}
export {
  useAlgoliaSearch
};
//# sourceMappingURL=use-algolia-search.js.map
